<template>
    <nav v-if="pages !== 1" class="pagination" role="navigation" aria-label="pagination">
        <ul class="pagination-list">
            <li>
                <router-link
                    :to="link(current - 1)"
                    class="pagination-link"
                    :disabled="current - 1 <= 0">
                    <i class="fas fa-arrow-left"></i>
                </router-link>
            </li>

            <li v-for="i in pages" :key="i">
                <router-link
                    :to="link(i)"
                    class="pagination-link"
                    :class="{'is-current': i === current}">

                    {{i}}
                </router-link>
            </li>

            <li>
                <router-link
                    :to="link(current + 1)"
                    class="pagination-link"
                    :disabled="current + 1 > pages">

                    <i class="fas fa-arrow-right"></i>
                </router-link>
            </li>
        </ul>
    </nav>
</template>

<script>
import { copy } from '../../utils/helpers';

export default {
    name: 'Paginator',
    props: {
        totalCount: Number,
        perPage: { type: Number, default: 10 },
        current: { type: Number, default: 1 },
        parameter: { type: String, default: 'page' },
    },
    computed: {
        pages() {
            return Math.ceil(this.totalCount / this.perPage);
        },
    },
    methods: {
        link(page) {
            const query = copy(this.$route.query);
            query[this.parameter] = page;
            return { name: this.$route.name, params: this.$route.params, query };
        },
    },
};
</script>
